module.exports = __webpack_public_path__ + "static/img/app-circle.551cf014.gif";